import { Injectable, inject } from '@angular/core';
import { MachineTaskApi } from 'src/api';
import { MachineTaskInfo } from 'src/api/machine-task.api';
import { TaskBaseService } from './task-base.service';

@Injectable()
export class MachineTaskService extends TaskBaseService<MachineTaskInfo> {
  private readonly machineTaskApi: MachineTaskApi;

  constructor() {
    const machineTaskApi = inject(MachineTaskApi);

    super(machineTaskApi);

    this.machineTaskApi = machineTaskApi;
  }

  /**
   * Gets all tasks related to a machine.
   */
  tasksByMachine$(machineId: string) {
    return this.machineTaskApi.tasksByMachine$(machineId);
  }
}
